import { Controller } from "stimulus"
import Rails from "@rails/ujs";

// Mirrors timeframe / location dropdown state across every instance
// of the `_insight_filters` partial on the page. Pages that render
// the partial multiple times (e.g. one dropdown per channel section
// on the campaign live report) get free synchronisation: clicking
// any instance updates the visible label on all of them and reloads
// the shared `#render_block`.
//
// Element targeting: prefers the stable CSS classes
// (`.js-timeframe-current` / `.js-location-current`) which are now
// emitted by the partial, but falls back to the legacy
// `#timeframe_current` / `#location_current` IDs so other pages /
// JS controllers that still read those IDs (blasts/interactions
// live_controller, the standalone insight pages) keep working.
export default class extends Controller {
  static targets = [
    "url",
    "locations",
    "time"
  ]

  initialize(){
  }

  timeSelector(event){
    document.getElementById('render_block').innerHTML = '<div class="spinner-border text-center text-primary m-t-100" role="status"><span class="sr-only">Loading...</span></div>'
    const params = {}
    if (this.locationsTarget.value == "true"){
      params["locations"] = this._readLocationActive()
    }
    const months = event.currentTarget.getAttribute('data-months')
    const option = event.currentTarget.getAttribute('data-option')
    this._syncTimeframeDisplays(months, option)
    params["months"] = months
    $.ajax({
      url: this.urlTarget.value,
      cache: false,
      type: 'GET',
      data: params,
    });

  }

  locationSelector(event){
    document.getElementById('render_block').innerHTML = '<div class="spinner-border text-center text-primary m-t-100" role="status"><span class="sr-only">Loading...</span></div>'
    const params = {}
    if (this.timeTarget.value == "true"){
      params["months"] = this._readTimeframeActive()
    }
    const locations = event.currentTarget.getAttribute('data-locations')
    const option = event.currentTarget.getAttribute('data-option')
    this._syncLocationDisplays(locations, option)
    params["locations"] = locations
    $.ajax({
      url: this.urlTarget.value,
      cache: false,
      type: 'GET',
      data: params,
    });
  }

  _syncTimeframeDisplays(months, option){
    const nodes = document.querySelectorAll('.js-timeframe-current')
    if (nodes.length > 0){
      nodes.forEach(function(el){
        el.setAttribute('data-active', months)
        el.textContent = option
      })
      return
    }
    const legacy = document.getElementById('timeframe_current')
    if (legacy){
      legacy.setAttribute('data-active', months)
      legacy.textContent = option
    }
  }

  _syncLocationDisplays(locations, option){
    const nodes = document.querySelectorAll('.js-location-current')
    if (nodes.length > 0){
      nodes.forEach(function(el){
        el.setAttribute('data-active', locations)
        el.textContent = option
      })
      return
    }
    const legacy = document.getElementById('location_current')
    if (legacy){
      legacy.setAttribute('data-active', locations)
      legacy.textContent = option
    }
  }

  _readTimeframeActive(){
    const node = document.querySelector('.js-timeframe-current') || document.getElementById('timeframe_current')
    return node ? node.getAttribute('data-active') : null
  }

  _readLocationActive(){
    const node = document.querySelector('.js-location-current') || document.getElementById('location_current')
    return node ? node.getAttribute('data-active') : null
  }
}
